import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiService } from '@/apiConnection/ApiService';
import { Utils } from '@/utils/utils';
import { CustomModalComponent } from '../custom-modal/custom-modal.component';

@Component({
  selector: 'app-custom-delete',
  imports: [
    CustomModalComponent,
  ],
  templateUrl: './custom-delete.component.html',
})
export class CustomDeleteComponent {

  @Input() id = 0;
  @Input() url = '';
  @Input() item = '';
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  constructor(
    private apiService: ApiService
  ) { }

  acceptFormFunction() {
    this.apiService.deleteById(this.url, this.id).subscribe({
      next: () => {
        this.acceptFunction.emit();
        this.closeFormFunction()
      },
      error: (error: any) => {
        Utils.notification.alert(Utils.extractErrorMessage(error) || `Error al eliminar ${this.item}`);
      },
    });
  }

  closeFormFunction() {
    this.closeFunction.emit();
  }

}
